import Box from '@mui/material/Box/Box';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography/Typography';
import { devices } from 'styles/breakpoints';
import { colors } from 'styles/colors';

export const WhyChooseUsWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  padding: 112px 0 0 0;

  @media (${devices.sm}) {
    padding: 112px 0;
  }
`;

export const WhyChooseUsTitle = styled(Typography)`
  max-width: 768px;
  color: ${colors.blue};
  font-weight: 700;
  font-size: 32px;
  line-height: 120%;
  text-align: center;

  @media (${devices.lg}) {
    font-size: 40px;
  }
`;

export const WhyChooseUsFactsWrapper = styled(Box)`
  display: flex;
  justify-content: flex-start;
  margin: 80px 0;
  width: 100%;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 48px;

  @media (${devices.sm}) {
    justify-content: space-between;
  }

  @media (${devices.md}) {
    gap: 0;
  }
`;

export const WhyChooseUsFactWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  gap: 16px;
  align-items: flex-start;

  @media (${devices.sm}) {
    max-width: 356px;
  }

  @media (${devices.md}) {
    max-width: 242px;
  }

  @media (${devices.lg}) {
    max-width: 282px;
  }
`;

export const IconWrapper = styled(Box)`
  & img {
    display: block;
  }
`;

export const WhyChooseUsFactsTitle = styled(Typography)`
  color: ${colors.mainDark};
  font-weight: 700;
  font-size: 20px;
  line-height: 140%;
  text-align: left;

  @media (${devices.sm}) {
    text-align: inherit;
  }
`;

export const WhyChooseUsFactsDescription = styled(Typography)`
  color: ${colors.mainDark};
  font-size: 16px;
  line-height: 150%;
  max-width: 456px;

  @media (${devices.sm}) {
    max-width: 100%;
  }
`;

export const BlueRectangle = styled(Box)`
  background-color: ${colors.blue};
  width: 100%;
  display: flex;
  padding: 48px 34px;
  justify-content: center;
  border-radius: 8px;
`;

export const BlueRectangleTypography = styled(Typography)`
  color: ${colors.white};
  line-height: 150%;
  font-weight: 600;
  font-size: 18px;
  text-align: center;
  max-width: 718px;
`;
